import { createMuiTheme, responsiveFontSizes } from "@material-ui/core/styles";
// ReportOnce "default" theme logo.
import roLogo from "../../images/reportonce-logo.svg";
// Nelson Alexander theme logo.
import naLogo from "../../images/na-logo-dashboard.svg";
import rtLogo from "../../images/rte.fddc0643.svg"
import mwLogo from "../../images/MW_Logo_horizontal_navy.svg"

// ReportOnce "default" theme settings.

let typography = {
    // Important (media) is required to override material ui default settings
    h3: {
        fontFamily: "filson-soft, sans-serif",
        fontWeight: 400,
        lineHeight: 1.5,
        fontSize: "30px",
        fontStyle: "normal",
        color: "#5A5A5A",
        "@media (max-width: 1600px)": {
            fontSize: "22px !important"
        },
        "@media (max-width: 540px)": {
            fontSize: "25px !important"
        },
        "@media screen and (max-width: 350px)": {
            fontSize: '18px !important',
        }
    },
    h4: {
        fontFamily: "filson-soft,sans-serif",
        fontWeight: 150,
        lineHeight: 1,
        fontSize: "24px",
        fontStyle: "normal",
        color: "#5A5A5A",
        "@media (max-width: 1600px)": {
            fontSize: "17px !important"
        },
        "@media (max-width: 540px)": {
            fontSize: "20px !important"
        },
        "@media screen and (max-width: 350px)": {
            fontSize: '14px !important',
        }
    },
    body1: {
        fontSize: "16px",
        fontFamily: "filson-soft,sans-serif",
        color: "#AAAAAA",
        fontWeight: 400,
        fontStyle: "normal",
        '@media screen and (max-width: 540px)': {
            fontSize: '15px',
          },
        "@media (max-width: 1600px)": {
            fontSize: "14px !important"
        },
        "@media screen and (max-width: 350px)": {
            fontSize: '12px !important',
        }
    },
    body2: {
        fontSize: "16px",
        fontFamily: "filson-pro,sans-serif",
        color: "#5A5A5A",
        fontWeight: 550,
        fontStyle: "normal",
        '@media screen and (max-width: 540px)': {
            fontSize: '15px',
          },
        "@media (max-width: 1600px)": {
            fontSize: "14px !important"
        },
        "@media screen and (max-width: 350px)": {
            fontSize: '12px !important',
        }
    },
    subtitle1: {
        fontSize: "14px",
        fontFamily: "filson-pro,sans-serif",
        color: "#AAAAAA",
        lineHeight: 1.3,
        fontWeight: 400,
        fontStyle: "normal",
        '@media screen and (max-width: 540px)': {
            fontSize: '13px',
          },
        "@media (max-width: 1600px)": {
            fontSize: "12px !important"
        },
        "@media screen and (max-width: 350px)": {
            fontSize: '10px !important',
        }
    },
    subtitle2: {
        fontSize: "14px",
        fontFamily: "filson-soft,sans-serif",
        color: "#AAAAAA",
        lineHeight: 2.5,
        paddingBottom: "0.7rem",
        fontWeight: 400,
        fontStyle: "normal",
        '@media screen and (max-width: 540px)': {
            fontSize: '13px',
          },
        "@media (max-width: 1600px)": {
            fontSize: "12px !important"
        },
        "@media screen and (max-width: 350px)": {
            fontSize: '10px !important',
        }
    },
    caption: {
        fontSize: "11px",
        fontFamily: "filson-soft,sans-serif",
        color: "#AAAAAA",
        fontWeight: 300,
        fontStyle: "normal",
        '@media screen and (max-width: 540px)': {
            fontSize: '9px',
          },
        "@media (max-width: 1600px)": {
            fontSize: "9px !important"
        }
    }
}

let ro = createMuiTheme({
    palette: {
        primary: {
            main: "#8abb2a",
            background: "#f4f3f3"
        },
        secondary: {
            main: "#434d3e",
        },
    },
    typography: typography,
});

// Nelson Alexander theme settings.
let na = createMuiTheme({
    palette: {
        primary: {
            main: "#1e0f14",
        },
        secondary: {
            main: "#a7a7a7",
        },
    },
    typography: typography,
});

let rt = createMuiTheme({
    palette: {
        primary: {
            main: "#02203B",
        },
        secondary: {
            main: "#02203B66",
        },
    },
    typography: typography,
});

let mw = createMuiTheme({
    palette: {
        primary: {
            main: "#0D1D34",
        },
        secondary: {
            main: "#A7AAB2",
        },
    },
    typography: typography,
});

const getTheme = (domain = "default") => {
    const themes = {
        ro: { theme: responsiveFontSizes(ro, {"factor": 5}), logo: roLogo },
        na: { theme: responsiveFontSizes(na, {"factor": 5}), logo: naLogo },
        rt: { theme: responsiveFontSizes(rt, {"factor": 5}), logo: rtLogo },
        mw: { theme: responsiveFontSizes(mw, {"factor": 5}), logo: mwLogo },
    };
    if (domain === 'default') {
        return themes["ro"]; // Return 'ro' the default ReportOnce theme.
    }

    return themes[domain];
};

export default getTheme;
